import { Col, Form, Select } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import { STYLE_MERCHANDISING_LIST } from "../../../apiServices/API_ENDPOINTS";
import { getData } from "../../../apiServices/common";
import CustomDatePicker from "common/CustomDatePicker";
import { isArrayAndHasValue } from "utils/functions";

// Fix round 1 (ux-sweep batch 2, finding 1): the visible Start/End Date
// pickers must show the same last-7-days-ending-today window that
// HourlyProductionDetailReport/index.js's mount effect fetches with (its own
// getDefaultDateRange()). Kept as a literal expression here (rather than
// importing from the page) to avoid a common -> feature import; if that
// page's default ever changes, this must change with it. Style stays unset
// (no initialValue) per the page's "no style_id = all styles" reasoning.
const HourlyProductionDetailFilterFields = () => {
  const [styleList, setStyleList] = useState([]);
  const { Option } = Select;

  const getStyleList = async (filterValues) => {
    const bodyData = {
      per_page: filterValues?.per_page || 20,
      style_no: filterValues?.style_no || "",
    };
    const response = await getData(STYLE_MERCHANDISING_LIST, false, bodyData);

    if (response && response?.data?.code === 200) {
      setStyleList(response?.data?.data?.data || []);
    }
  };

  useEffect(() => {
    getStyleList();
  }, []);

  return (
    <>
      <Col span={4}>
        <Form.Item
          label="Start Date"
          name="start_date"
          required
          initialValue={moment().subtract(6, "days")}
          rules={[
            {
              required: true,
              message: "Start Date is required",
            },
          ]}
        >
          <CustomDatePicker style={{ width: "100%" }} size="small" />
        </Form.Item>
      </Col>
      <Col span={4}>
        <Form.Item
          label="End Date"
          name="end_date"
          required
          initialValue={moment()}
          rules={[
            {
              required: true,
              message: "End Date is required",
            },
          ]}
        >
          <CustomDatePicker style={{ width: "100%" }} size="small" />
        </Form.Item>
      </Col>
      <Col span={4}>
        <Form.Item label="Style No." name="style_id">
          <Select
            showSearch
            placeholder="Select a Style"
            optionFilterProp="children"
            size="small"
            onSearch={(value) => getStyleList({ style_no: value })}
            allowClear
            onClear={() => getStyleList()}
          >
            {isArrayAndHasValue(styleList) &&
              styleList.map((style) => (
                <Option value={style.id} key={style.id}>
                  {style.style_no}
                </Option>
              ))}
          </Select>
        </Form.Item>
      </Col>
    </>
  );
};

export default HourlyProductionDetailFilterFields;
